export default __webpack_public_path__ + "static/media/rosko.5d2b96b4.png";